// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../scout/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination[data-v-e0f09652]{text-align:center}.pagination .current[data-v-e0f09652]{font-size:1.8rem;font-weight:700}.pagination .next[data-v-e0f09652],.pagination .prev[data-v-e0f09652]{cursor:pointer;padding:0 5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
